import { useSearchParamsContext } from '@internal/blocks/SearchResultsBlock/SearchParamsContext';
import { MachineSubType } from '@internal/utils/machine/MachineType';
import { localeNamespace } from '@internal/utils/machine/i18n/Locale';
import {
    MachineSubTypeSelectFilter,
    useMachineSubTypeOptions,
} from '@renderer-ui-library/molecules';
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting';
import { translations } from 'i18n/translations';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import { SearchFilterCategory } from './SearchFilterCategory/SearchFilterCategory';

export const MachineSubTypeFilter: React.FC = React.memo(() => {
    const { searchParams } = useSearchParamsContext();
    const { machineSubType, machineType } = searchParams;
    const { gotoSearchResults } = useSearchResultsRouting();
    const { t } = useTranslation(localeNamespace.common);
    const { machineSubTypeOptions } = useMachineSubTypeOptions(
        searchParams.machineType,
    );

    const handleChange = useCallback(
        (machineSubType: MachineSubType | null) => {
            gotoSearchResults({
                ...searchParams,
                machineSubType: machineSubType ?? undefined,
                amount: undefined,
            });
        },
        [gotoSearchResults, searchParams],
    );

    if (machineSubTypeOptions.length === 0) {
        return null;
    }

    return (
        <SearchFilterCategory
            title={t(translations.searchResultsFiltersMachineSubTypeLabel)}
        >
            <MachineSubTypeSelectFilter
                value={machineSubType ?? null}
                options={machineSubTypeOptions}
                onChange={handleChange}
                machineType={searchParams.machineType}
            />
        </SearchFilterCategory>
    );
});

MachineSubTypeFilter.displayName = 'MachineSubTypeFilter';
